import type { SupabaseClient } from "@supabase/supabase-js";
import type { ServerMessageRow } from "@/lib/chat-message-state";

/** Primeira página cabe na área do chat. "Carregar anteriores" usa o mesmo tamanho. */
export const CHAT_MESSAGE_PAGE_SIZE = 20;

/** Teto do preenchimento de lacuna. O aviso cobre o fluxo normal. */
export const CHAT_MESSAGE_GAP_LIMIT = 50;

let chatMessagesRpcDisabled = false;

function isMissingChatMessagesRpc(error: { code?: string; message?: string }): boolean {
  return error.code === "PGRST202" || /fetch_chat_messages/i.test(error.message ?? "");
}

export type FetchChatMessagesParams = {
  conversationIds: string[];
  olderThan?: string | null;
  since?: string | null;
  limit: number;
};

/**
 * Página ou lacuna de mensagens com a permissão da conversa calculada uma vez.
 * `null` = a função falhou; o chamador usa a busca antiga.
 */
export async function fetchChatMessageRows(
  client: SupabaseClient,
  params: FetchChatMessagesParams,
): Promise<ServerMessageRow[] | null> {
  if (chatMessagesRpcDisabled || params.conversationIds.length === 0) return null;

  const { data, error } = await client.rpc("fetch_chat_messages", {
    p_conversation_ids: params.conversationIds,
    p_limit: params.limit,
    ...(params.olderThan ? { p_older_than: params.olderThan } : {}),
    ...(params.since ? { p_since: params.since } : {}),
  });

  if (error) {
    if (isMissingChatMessagesRpc(error)) chatMessagesRpcDisabled = true;
    console.error("fetch_chat_messages:", error);
    return null;
  }

  if (!Array.isArray(data)) return null;
  return data as ServerMessageRow[];
}
